
import store from '../store/index';

export default function () {
    return store.dispatch('profile/loadSession');
}
